/**
 * ObjectCheckboxField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


/**
 * ObjectCheckboxField is an editing component for (boolean) checkbox fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectCheckboxField extends React.Component {

    render() {

        const { fieldDef, classes } = this.props;

        return <FormControlLabel
            label={fieldDef.name}
            className={classes.checkbox}
            control={
                <Checkbox
                    checked={this.props.value == null || this.props.value === "" ? !!fieldDef.default : !!this.props.value}
                    disabled={this.props.readOnly}
                    onChange={event => this.props.onObjectValueChange(fieldDef.id, event.target.checked)}
                    color="primary"
                />
            }
        />;
    }
}

ObjectCheckboxField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    checkbox: {
        marginTop: 16
    }
};

export default withStyles(styles)(ObjectCheckboxField);